"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.PortalExit = void 0;
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _dataQa = _interopRequireDefault(require("@platform-ui/dataQa"));
var _constants = require("./constants");
var _excluded = ["dataQaType", "dataQaData", "tagName", "exitId"];
var PortalExit = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _extends2;
  var _props$dataQaType = props.dataQaType,
    dataQaType = _props$dataQaType === void 0 ? 'uikit/portalExit' : _props$dataQaType,
    dataQaData = props.dataQaData,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    _props$exitId = props.exitId,
    exitId = _props$exitId === void 0 ? '' : _props$exitId,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(tagName, (0, _extends3.default)({}, rest, (0, _dataQa.default)({
    dataQaType: dataQaType,
    dataQaData: dataQaData
  }), (_extends2 = {
    ref: ref
  }, _extends2[_constants.PORTAL_EXIT_ATTR_NAME] = exitId, _extends2)));
});
exports.PortalExit = PortalExit;